import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";

export const MobileCTA = ({ heroFormId, label = "RESERVE MY FREE SEAT", targetId = "register", onClick }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const target = document.getElementById(heroFormId);
    if (!target) return;
    const io = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 },
    );
    io.observe(target);
    return () => io.disconnect();
  }, [heroFormId]);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
      style={{ background: "linear-gradient(to top, rgba(2,2,42,0.96), rgba(2,2,42,0.7))" }}
    >
      <button
        data-testid="mobile-sticky-cta"
        onClick={() => {
          if (onClick) onClick();
          scrollToId(targetId);
        }}
        className="glint w-full bg-[var(--accent)] text-[var(--background-deep)] font-semibold text-sm tracking-[0.12em] py-4 rounded-[4px]"
      >
        {label}
      </button>
    </div>
  );
};
